export default __webpack_public_path__ + "static/media/001-balloon-white.294775ab.svg";